import React from 'react'
import {Logo, LanguageSelect} from '@/components'
import {Theme} from '@/constants'
import styles from './styles.scss'

export const AuthLayout: React.FC<{children: React.ReactNode}> = ({ children }) => {

    return <div className={styles.layout}>
        <LanguageSelect className={styles.language} />
        <div className={styles.content}>
            <div className={styles.header}>
                <Logo type={Theme.LIGHT} />
            </div>
            {children}
        </div>
    </div>
}
